import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import MoveDownOutlinedIcon from '@mui/icons-material/MoveDownOutlined';
import FolderCopyOutlinedIcon from '@mui/icons-material/FolderCopyOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import { PATH_ADMIN } from '../../routes/paths';

const adminSidebarConfig = [
  {
    subheader: 'menu.admin_console',
    items: [
      {
        title: 'menu.admin',
        path: PATH_ADMIN.analytics,
        icon: <BarChartOutlinedIcon sx={{ width: '100%', height: '100%' }} />
      },
      {
        title: 'menu.organizations',
        path: PATH_ADMIN.organizations,
        icon: <BusinessOutlinedIcon sx={{ width: '100%', height: '100%' }} />
      },
      {
        title: 'menu.learning_cycles',
        path: PATH_ADMIN.learningCycles,
        icon: <AutoStoriesOutlinedIcon sx={{ width: '100%', height: '100%' }} />
      },
      {
        title: 'menu.topic_migration',
        path: PATH_ADMIN.topicMigration,
        icon: <MoveDownOutlinedIcon sx={{ width: '100%', height: '100%' }} />
      },
      {
        title: 'menu.resource_migration',
        path: PATH_ADMIN.resourceMigration,
        icon: <FolderCopyOutlinedIcon sx={{ width: '100%', height: '100%' }} />
      }
    ]
  }
];

export default adminSidebarConfig;
